const routes = {
  '/': '',
  '/dashboard': 'Dashboard',
  '/users': 'User List',
  '/add-user': 'Add User',
  '/profile': 'Profile',
  '/orders': 'Orders',
  '/brands': 'Brand List',
  '/add-brand': 'Add Brand',
  '/categories': 'Category List',
  '/add-category': 'Add Category',
  '/products': 'Product List',
  '/add-product': 'Add Product',
  '/inventory': 'Shop Inventories',
  '/add-inventory': 'Add to Inventory',
  '/locations': 'Delivery Locations',
  '/add-location': 'Add Location',
  '/assign': 'Assign Location',
  '/maps': 'Maps',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js